import { render, staticRenderFns } from "./project_show.vue?vue&type=template&id=59b5f6b2&"
import script from "./project_show.vue?vue&type=script&lang=js&"
export * from "./project_show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports